// extracted by mini-css-extract-plugin
module.exports = {"theme":"#ff9811"};